<div (click)="tagClicked(tag)" [ngClass]="isActive ? 'active' : 'inactive'">
  <span>{{ tag.name }}</span>
</div>
